import { ID } from "@nova/constants"
import { trimMiddle } from "@nova/util-strings"
import classNames from "classnames"
import { RadioButton } from "@nova/ds-component-radio-button"
import { useCallback } from "react"
import * as Icons from "@nova/component-icons"

type LayersRadioButtonProps = {
    layerId: ID
    layerName: string
    selectedLayerId: ID
    setSelectedLayerId: (id: ID) => void
    disabled?: boolean
    warning?: string
}

export const LayersRadioButton = ({
    layerId,
    layerName,
    selectedLayerId,
    setSelectedLayerId,
    disabled,
    warning,
}: LayersRadioButtonProps) => {
    const isActive = selectedLayerId === layerId

    const handleClick = useCallback(() => {
        if (disabled) return
        if (isActive) setSelectedLayerId("")
        else setSelectedLayerId(layerId)
    }, [isActive, setSelectedLayerId, layerId, disabled])

    return (
        <div
            className={classNames("flex items-center justify-between gap-2 py-1 px-2 rounded-md", {
                "cursor-not-allowed": disabled,
                "cursor-pointer hover:bg-gray-700": !disabled,
            })}
            onClick={handleClick}
        >
            <div className="flex items-center gap-2">
                <RadioButton
                    isSelected={layerId === selectedLayerId}
                    onClick={handleClick}
                    size="small"
                />
                <small
                    className={classNames({
                        "text-gray-100": !isActive,
                        "text-gray-0": isActive,
                    })}
                >
                    {trimMiddle(layerName, { maxLength: !!warning ? 13 : 30, distribution: 0 })}
                </small>
            </div>
            {!!warning && (
                <div className="flex items-center gap-2">
                    <Icons.ExtraSmallIcon Icon={Icons.CloudAlert} className="text-yellow-500" />
                    <small className="text-gray-100">{warning}</small>
                </div>
            )}
        </div>
    )
}
